import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Box, CircularProgress, Button, Divider, TextField } from '@mui/material';
import ProductInfo from 'components/product/ProductInfo';
import { updateProductObj, setProductUpdateproductstatusModal } from 'store/slice/PharmaSlice';

import ErrorMessage from 'core/components/ErrorMessage';
import SuccessMessage from 'core/components/SuccessMessage';
import { updateProductStatusAPI } from '../../../../api/OmsOrdermgmtWebServices';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    //border: '2px solid #000',
    boxShadow: 24,
    borderRadius: 2,
    p: 4,
};
export default function UpdateProductStatusAPI() {
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {

    }, [productObj]);

    const apiSuccess = (response) => {
        setApiInProgress(false);
        dispatch(updateProductObj(response.productInfo))
        if (response.productInfo.statusname === "PLANNING")
            setSuccessMsg("Status of '" + productObj.title + "' is set to Planning !!!");
        else
            setSuccessMsg("Unable to set status !!!");
    }
    const apiFailure = (apiErrMsg) => {
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
    }
    const handleApiSubmmission = () => {
        setErrMsg('')
        setApiInProgress(true);

        updateProductStatusAPI({
            productId: productObj.id,
            status: "PLANNING"
        }, apiSuccess, apiFailure)

    }
    const getComponent = () => {
        if (apiInProgress) return <CircularProgress />
        if (successMsg !== '') return <Grid container sx={{ justifyContent: "center", alignItems: "center", padding: 1 }}><SuccessMessage message={successMsg} /></Grid>

        return <>
            <Grid container direction="row" justifyContent="space-between" >
                <Button onClick={() => { handleApiSubmmission() }}> Yes</Button>
                <Button onClick={() => { handleNoClick() }}> No</Button>
            </Grid>
        </>
    }

    const handleNoClick = () => {
        dispatch(setProductUpdateproductstatusModal(false));
    }
    return (
        <>
            <Grid container direction="column" sx={{ justifyContent: "center", alignItems: "center", padding: 1 }}>
                <Box sx={style} width='50%'>
                    <Grid container  direction="column" sx={{ justifyContent: "center", alignItems: "center", padding: 1 }}>

                        <Typography id="modal-modal-title" variant="h3" color="primary">
                            CONFIRMATION
                        </Typography>
                        <Grid sx={{ width: '100%', borderBottom: '1px solid #d9d9d9' }}></Grid>
                        <Typography color="secondary" gutterBottom variant="h6" sx={{ padding: 3 }}>
                            <i>Are you sure that design work of Product '{productObj.title}' is complete and good to start Raw Material planning?</i>
                        </Typography>
                    </Grid>
                    <Box height="50px"></Box>
                    <Divider />

                    {getComponent()}

                </Box>

            </Grid>
        </>
    )
}